import React, { useState, useEffect } from 'react';
import NavLinks from '../Navbar/NavLinks'; // Assumed external component for links
import { HashLink } from 'react-router-hash-link';
import img from '../Navbar/trasperentlogo.png'; // Adjusted relative path

const NavBar = () => {
    const [top, setTop] = useState(true);
    const [isOpen, setIsOpen] = useState(false);

    // Toggle menu
    const handleMenuToggle = () => {
        setIsOpen(!isOpen);
    };

    // Handle scroll events for navbar background and shadow
    useEffect(() => {
        const handleScroll = () => {
            window.pageYOffset > 10 ? setTop(false) : setTop(true);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <nav
                className={`fixed top-0 w-full z-30 transition-all duration-300 ${
                    !top
                        ? 'bg-white/85 backdrop-blur-md border-b border-slate-100 shadow-sm py-2'
                        : 'bg-transparent py-4'
                }`}
            >
                <div className="container mx-auto px-6 max-w-7xl">
                    <div className="flex justify-between items-center">
                        {/* Logo */}
                        <div className="flex items-center">
                            <HashLink smooth to="/#hero" className="flex items-center">
                                <img
                                    src={img}
                                    className="h-10 md:h-12 w-auto transition-transform duration-300 hover:scale-105"
                                    alt="Logo"
                                />
                            </HashLink>
                        </div>

                        {/* Nav Links for larger screens */}
                        <div className="hidden lg:flex items-center space-x-1">
                            <NavLinks />
                        </div>

                        {/* Hamburger Menu for smaller screens */}
                        <div className="lg:hidden">
                            <button
                                className="p-2 rounded-lg text-slate-700 hover:bg-slate-100 focus:outline-none transition-colors"
                                onClick={handleMenuToggle}
                                aria-label="Toggle Menu"
                            >
                                <svg
                                    className="h-6 w-6 fill-current"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                >
                                    {isOpen ? (
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                                        />
                                    ) : (
                                        <path
                                            fillRule="evenodd"
                                            d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2z"
                                        />
                                    )}
                                </svg>
                            </button>
                        </div>
                    </div>

                    {/* Dropdown menu for mobile */}
                    {isOpen && (
                        <div className="lg:hidden mt-2">
                            <div className="flex flex-col py-3 px-4 bg-white/95 backdrop-blur-md rounded-2xl shadow-xl border border-slate-100 space-y-3">
                                <NavLinks mobile={true} setIsOpen={setIsOpen} />
                            </div>
                        </div>
                    )}
                </div>
            </nav>

            {/* Spacer to avoid overlap with content */}
            <div className="h-20"></div>
        </>
    );
};

export default NavBar;
